import React from "react";

const FileInfoChild = ({ fileType, fileName }) => {
  return (
    <div className="fileTypeAndName">
      <p className="fileType">{fileType}</p>
      <span className="fileTypeName">{fileName}</span>
    </div>
  );
};

export default FileInfoChild;
